
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldNumber from './form-field-number'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldnumber"
    }}>{`FormFieldNumber`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "number-field"
    }}>{`Number field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a numerical-only value. Includes built-in browser validation.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldNumber {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} labelText="Label" labelTag="Tag" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"1000000\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} placeholder="1000000" mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={5} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} error="Notice" labelText="Label" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={6} __code={'<FormFieldNumber labelText=\"Label\" id=\"123\" value=\"1234\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
    <FormFieldNumber labelText="Label" id="123" value="1234" disabled mdxType="FormFieldNumber" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "number-field-adjacent"
    }}>{`Number field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For a numerical-only value. Includes built-in browser validation.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={8} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldNumber adjacent {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "number-field-slim"
    }}>{`Number field (slim)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For a numerical-only value. Includes built-in browser validation. Use where inputs are nested or constrained by layout.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={10} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      slim\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldNumber {...state} labelText="Label" id="123" slim onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <Playground __position={11} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      slim\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} slim labelText="Label" labelTag="Tag" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={12} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      slim\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"1000000\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} slim labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} placeholder="1000000" mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={13} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      slim\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} slim helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={14} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      {...state}\n      error=\"Notice\"\n      slim\n      labelText=\"Label\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldNumber {...state} error="Notice" slim labelText="Label" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={15} __code={'<FormFieldNumber slim labelText=\"Label\" id=\"123\" value=\"1234\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
    <FormFieldNumber slim labelText="Label" id="123" value="1234" disabled mdxType="FormFieldNumber" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "number-field-slim-adjacent"
    }}>{`Number field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For a numerical-only value. Includes built-in browser validation. Use where inputs are nested or constrained by layout.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={17} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldNumber\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      slim\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldNumber
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldNumber adjacent {...state} labelText="Label" id="123" slim onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldNumber" />}
      </State>
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldNumber} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;